import { ArgsType, Field } from '@nestjs/graphql'
import { BaseGetByIdArgs } from '../base/baseGetById.args'

@ArgsType()
export class PenNameGetByIdArgs extends BaseGetByIdArgs<PenNameGetByIdArgs> {
  @Field(t => Boolean, { nullable: true })
  getAverageRating?: boolean
}
